import { CatalogPage } from "../pages/catalog";
import { ExtractPage } from "../pages/extract";
import { MyRedemptionPage } from "../pages/my-redemptions";

export const customerProtectedRoutes = [
    {
        label: 'Catálogo',
        path: '/catalogo',
        element: <CatalogPage />
    },
    {
        label: 'Extrato',
        path: '/extrato',
        element: <ExtractPage />
    },
    {
        label: 'Meus resgates',
        path: '/meus-resgates',
        element: <MyRedemptionPage />
    }
];